import React from 'react'
import './GameRoutes.scss'
import dota from '../../assets/dota.png'
import freefire from '../../assets/freefire.png'
import molen from '../../assets/molen.png'
import valorant from '../../assets/valorant.png'
import {NavLink} from 'react-router-dom'

const GameRoutes = () => {
    return (
        <>
            <div className="game-route-container">
                <div className="game-choose">
                    <NavLink to="/dota" className="game-click" activeClassName="game-click-active">
                    <div>
                        <img src={dota} alt="dota"/>
                    </div>
                    </NavLink>
                    <NavLink to="/ff" className="game-click" activeClassName="game-click-active">
                    <div>
                        <img src={freefire} alt="freefire"/>
                    </div>
                    </NavLink>
                    <NavLink to="/valor" className="game-click" activeClassName="game-click-active">
                    <div>
                        <img src={valorant} alt="valorant"/>
                    </div>
                    </NavLink>
                    <NavLink to="/molen" className="game-click" activeClassName="game-click-active">
                    <div>
                        <img src={molen} alt="molen"/>
                    </div>
                    </NavLink>
                </div>
            </div>
        </>
    )
}

export default GameRoutes
